import ArrayHelper from '../helpers/ArrayHelper';
import { ErrorTypes, ErrorDetails } from '../hlsjs/errors';
import Event from '../hlsjs/events';
import KeySystem from '../KeySystems';
import { logger } from '../hlsjs/utils/logger';
import Utils from '../HlsUtils';
import DrmUtils from './DrmUtils';

class EME {
	constructor(hls, keySystemName, obtainKeySystemConfigCallback, totalSessions) {
		this._obtainKeySystemConfigCallback = obtainKeySystemConfigCallback;
		this._keySystemName = keySystemName;
		this._keySystemConfig = null;
		this._keySystem = null;
		this._caps = null;
		this._hls = hls;
		this._totalSessions = totalSessions;

		if(this._keySystemName === KeySystem.WIDEVINE) {
			this._keySystem = 'com.widevine.alpha';
		}
		else if(this._keySystemName === KeySystem.PLAYREADY) {
			this._keySystem = 'com.microsoft.playready';
		}
		else if(this._keySystemName === KeySystem.FAIRPLAY) {
			this._keySystem = 'com.apple.fps.2_0';
		}
		else if(this._keySystemName === KeySystem.CLEARKEY) {
			this._keySystem = 'org.w3.clearkey';
		}
	}

	obtainData(dataPromise, event) {
		if(dataPromise) {
			dataPromise.then((data) => {
				try {
					let promise = event.target.update(new Uint8Array(data));

					if(promise) {
						promise.catch((err) => {
							this.onError(err);
						});
					}
				}
				catch(err) {
					this.onError(err);
				}
			})
			.catch((err) => {
				this.onError({ message: err });
			});
		}
		else {
			this.onError({ message: ' The promise is not defined in the keySystemConfig' });
		}
	}

	obtainCertificate(event) {
		if(this._keySystemConfig) {
			this.obtainData(this._keySystemConfig.certificate, event);
		}
		else {
			this.onError({ message: ' The keySystemConfig has not been set' });
		}
	}

	obtainLicense(event) {
		if(this._keySystemConfig && this._keySystemConfig.obtainLicenseCallback) {
			//Normalise cdm data
			let data = ArrayHelper.makeUint8Array(event.message);

			// if we are Tizen, and PlayReady, then reformat the challenge as if it were the IE/Edge reformat
			// so the same client code can be used for both platforms.
			if( Utils.isTizen() && this._keySystemName === KeySystem.PLAYREADY ) {
				data = DrmUtils.wrapPlayReadyChallengeAsPlayReadyObjectUcs16( data );
			}

			this.obtainData(this._keySystemConfig.obtainLicenseCallback(this._keySystemName, data), event);
		}
		else {
			this.onError({ message: ' The keySystemConfig has not been set' });
		}
	}

	onError(err) {
		logger.error(`EME error : ${err.message}`);
		if (this._hls) {
			this._hls.trigger(Event.ERROR, {
				type: ErrorTypes.MEDIA_ERROR,
				details: ErrorDetails.DRM_ERROR,
				fatal: true,
				reason: err.message,
			});
		}
	}

	get keySystem() {
		return this._keySystem;
	}

	get keySystemName() {
		return this._keySystemName;
	}

	static get capabilities() {
		if(!this._caps) {
			this._caps = new Promise((resolve) => {
				let keySystems = ['com.apple.fps.2_0', 'com.microsoft.playready', 'com.widevine.alpha', 'org.w3.clearkey'];
				let supportedKeySystems = [];
				let i = 0;

				if(window.navigator.requestMediaKeySystemAccess) {
					let count = 0;

					let options = [{
						initDataTypes: ['cenc'],
					}];

					options[0].audioCapabilities = [{
						contentType: 'audio/mp4; codecs="mp4a.40.2"',
					}];

					options[0].videoCapabilities = [{
						contentType: 'video/mp4; codecs="avc1.4d401f"',
					}];

					for (i = 0; i < keySystems.length; i++) {
						navigator.requestMediaKeySystemAccess(keySystems[i], options)
						.then((keySystemAccess) => {	// eslint-disable-line no-loop-func
							supportedKeySystems.push(keySystemAccess.keySystem);
							count++;

							if (count === keySystems.length) {
								resolve(supportedKeySystems);
							}
						})
						.catch(() => {					// eslint-disable-line no-loop-func
							count++;

							if(count === keySystems.length) {
								resolve(supportedKeySystems);
							}
						});
					}
				}
				else {
					let legacyMediaKeys = window.WebKitMediaKeys || window.MSMediaKeys || window.WEBKITMediaKeys;

					if (legacyMediaKeys) {
						for (i = 0; i < keySystems.length; i++) {
							if (legacyMediaKeys.isTypeSupported(keySystems[i], 'video/mp4')) {
								supportedKeySystems.push(keySystems[i]);
							}
						}
					}

					resolve(supportedKeySystems);
				}
			});
		}

		return this._caps;
	}

	setKeySystemConfig(keySystemData) {
		if(this._obtainKeySystemConfigCallback) {
			this._keySystemConfig = this._obtainKeySystemConfigCallback(this._keySystemName, keySystemData);
		}
	}
}

export default EME;



// WEBPACK FOOTER //
// ./src/drm/EME.js